import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { StyledContainer } from './MenuItem.styled';

interface IMenuItemProps extends React.HTMLAttributes<HTMLDivElement> {
	text: string;
	icon: string | undefined;
	active: boolean;
	onClick: React.MouseEventHandler<HTMLElement>;
	onMouseEnter?: React.MouseEventHandler<HTMLElement>;
	onMouseLeave?: React.MouseEventHandler<HTMLElement>;
}

const MenuItem: React.FC<IMenuItemProps> = ({
	text,
	icon,
	active,
	onClick,
	onMouseLeave,
}: IMenuItemProps) => {
	return (
		<StyledContainer
			$active={active}
			onClick={(e) => {
				onClick(e);
				playSound(Sound.ClickButton);
			}}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
			onMouseLeave={onMouseLeave}
		>
			<img src={icon} width={16} height={16} />
			<Text>{text}</Text>
		</StyledContainer>
	);
};

export { MenuItem };
